<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { Checkbox } from 'primevue';
import { useListManageReportApi } from '../api/listManageReportApi';
import type { ReportResponse } from '../models/ReportResponse';
import { useToggleReportApi } from '../api/toggleReportApi';
import { useLanguageStore } from 'shared/translations/stores/languageStore';
import { storeToRefs } from 'pinia';

const listManageReportApi = useListManageReportApi();
const toggleReportApi = useToggleReportApi();
const languageStore = useLanguageStore();
const { translations } = storeToRefs(languageStore);

const reports = ref<ReportResponse[]>([]);

onMounted(async () => {
  reports.value = await listManageReportApi.execute();
});

async function toggleReport(report: ReportResponse) {
  const booleanValue = Boolean(report.enabled);
  await toggleReportApi.execute({
    reportType: report.reportType,
    enabled: booleanValue,
  });
}
</script>

<template>
  <div>
    <div v-for="report in reports" :key="report.reportType" class="feature-flag">
      <div class="mt-2">
        <Checkbox
          v-model="report.enabled"
          @change="() => toggleReport(report)"
          class="me-2"
          size="small"
          binary
        />
        <label>{{ translations.reports.reportName(report.reportType) }}</label>
      </div>
    </div>
  </div>
</template>
